// extracted by mini-css-extract-plugin
export var fullWidthButton = "_s3-0";